import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { hasRoleByCode, hasRoleById } from 'lib/utils'

const namespace = 'profilePage.profileFields.validation.'

export default function useProfileFieldsValidation(user) {
  const [errors, setErrors] = useState({})
  const { t } = useTranslation()
  const required = t(`${namespace}required`)

  const rules = {
    password: value => {
      if (!value && !user?.id) return required
    },
    email: value => {
      if (!value && !user?.id) return required
    },
    phone: value => {
      if (!value && !user?.id) return required
    },
    iin: value => {
      if (!value && !user?.id) return required
    },
    managersProjectId: value => {
      if (
        !value &&
        (hasRoleById('CP', 'PURCHASER', user) ||
          hasRoleByCode('HEAD_SALES', user))
      ) {
        return t(`${namespace}reqPurchaserDepartment`)
      }

      if (
        !value &&
        (hasRoleById('CS', 'MANAGER', user) ||
          hasRoleByCode('HEAD_SALES', user))
      ) {
        return t(`${namespace}reqManagerDepartment`)
      }
    },
    headManagerUserId: value => {
      if (!value && hasRoleById('CP', 'PURCHASER', user)) {
        return t(`${namespace}reqPurchaserRgv`)
      }

      if (!value && hasRoleById('CS', 'MANAGER', user)) {
        return t(`${namespace}reqManagerRgp`)
      }
    }
  }

  const validate = (onSuccess = () => {}) => {
    const errors = {}

    Object.keys(rules).forEach(key => {
      const error = rules[key](user[key])
      if (error) errors[key] = error
    })

    setErrors(errors)

    if (Object.keys(errors).length === 0) onSuccess()
    else window.scrollTo({ top: 100, behavior: 'smooth' })
  }

  const resetErrors = () => setErrors({})

  const resetError = key => {
    const newErrors = { ...errors }
    delete newErrors[key]
    setErrors(newErrors)
  }

  return { errors, validate, resetErrors, resetError }
}
